export enum MobileVersionReviewRoutesEnum {
  root = 'wrong-app-version',
  main = '',
}
